<template>
  <section class="py-5">
    <div class="container">
      <div class="card border-0 shadow-sm">
        <div class="card-body p-4 p-md-5">
          <h1 class="mb-3">Terms of Service</h1>
          <p class="text-muted">Last updated: March 28, 2026</p>

          <p>
            These Terms of Service govern your use of the FinPlan application.
            By accessing or using FinPlan, you agree to these Terms.
          </p>

          <h2 class="h4 mt-4">1. Use of the Service</h2>
          <p>
            FinPlan is provided as a personal finance management tool. You agree to use the service
            only in a lawful manner and not to misuse, disrupt, or attempt unauthorized access to it.
          </p>

          <h2 class="h4 mt-4">2. Account Responsibility</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account and for activity
            that occurs under your account.
          </p>

          <h2 class="h4 mt-4">3. User Data</h2>
          <p>
            You retain responsibility for the data you enter into FinPlan, including financial records,
            account details, categories, transactions, and plans.
          </p>

          <h2 class="h4 mt-4">4. Availability</h2>
          <p>
            We may update, modify, suspend, or discontinue the service or any part of it at any time,
            with or without notice.
          </p>

          <h2 class="h4 mt-4">5. No Financial Advice</h2>
          <p>
            FinPlan is a software tool for organizing financial information. It does not provide
            financial, legal, tax, or investment advice.
          </p>

          <h2 class="h4 mt-4">6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, FinPlan is provided on an “as is” and “as available” basis.
            We are not liable for indirect, incidental, special, consequential, or exemplary damages,
            including loss of data, loss of profits, or service interruption.
          </p>

          <h2 class="h4 mt-4">7. Termination</h2>
          <p>
            We may suspend or terminate access to the service if these Terms are violated
            or if required for security, maintenance, or legal reasons.
          </p>

          <h2 class="h4 mt-4">8. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the service after changes
            become effective constitutes acceptance of the updated Terms.
          </p>

          <h2 class="h4 mt-4">9. Contact</h2>
          <p class="mb-0">
            For questions regarding these Terms, contact:
            <a href="mailto:thebestrubl@gmail.com">thebestrubl@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>